<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="IsPreviewTrue && !isEditing">
      {{LabelConstants.CustomerPreview}}</h4>
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="!IsPreviewTrue && !isEditing">
      {{LabelConstants.AddNewCustomer}}</h4>
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="!IsPreviewTrue && isEditing">
      {{LabelConstants.EditCustomer}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="main-form">
      <form [formGroup]="AddCustomerForm" (ngSubmit)="submitCustomerForm()" novalidate>
        <!-- Customer Image -->
        <div class="row">
          <div class="col-lg-3 col-12 mb-2 text-center text-md-left">
            <div class="position-relative upload-btn">
              <img (error)="handleImageError()"
                [src]="imageSrc ? imageSrc : '../../../../assets/img/default-customer-profile.svg'"
                class="me-2 profile-image" alt="Customer Image" width="135" height="135" />
              <label for="uplaod-btn"><img src="../../../../assets/img/img-icon.svg" class="img-icon" alt=""
                  *ngIf="!IsPreviewTrue" /></label>
              <input type="file" (change)="onFileSelected($event)" formControlName="CustomerImage" id="uplaod-btn"
                accept="image/*" />
            </div>
          </div>
        </div>
        <!-- Firstname / Lastname -->
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.FirstName}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input placeholder="Enter First Name" matInput formControlName="FirstName"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="49" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted &&
              AddCustomerForm.get('FirstName').hasError('required')">
                {{ ErrorMessages.FirstNameRequired }}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.LastName}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Last Name" formControlName="LastName"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="49" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted &&
              AddCustomerForm.get('LastName').hasError('required')">
                {{ ErrorMessages.LastNameIsRequired }}
              </mat-error>
            </div>
          </div>
        </div>
        <!-- Email/PhoneNo -->
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.Email}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input placeholder="Enter Email" matInput formControlName="Email"
                  oninput="this.value = this.value.trimStart().toLowerCase()" type="text" maxlength="99" />
              </mat-form-field>
              <mat-error *ngIf="submitted && AddCustomerForm.get('Email').hasError('required') ">
                {{ ErrorMessages.EmalRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && CustomerFormControl['Email'].errors?.['pattern']">
                {{ErrorMessages.EmailNotValid}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.PhoneNumber}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input placeholder="Enter Phone Number" matInput formControlName="PhoneNumber"
                  oninput="this.value = this.value.replace(/^\s+|\D+/g, '').substring(0, 15)" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted &&
              AddCustomerForm.get('PhoneNumber').hasError('required')">
                {{ ErrorMessages.PhoneNoRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && CustomerFormControl['PhoneNumber'].errors?.['minlength']">
                {{ErrorMessages.PhoneNumberNotValid}}
              </mat-error>
            </div>
          </div>
        </div>
        <!-- Address -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.AddressL1}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Address Line 1" formControlName="Address"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="100" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddCustomerForm.get('Address').hasError('required')">
                {{ ErrorMessages.AddressRequired }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.State}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Address Line 2" formControlName="State"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="100" />
              </mat-form-field>
              <mat-error *ngIf="
                submitted && AddCustomerForm.get('State').hasError('required')">
                {{ ErrorMessages.StateRequired }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.PostalCode}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Postal Code" formControlName="PostalCode" maxlength="8"
                  oninput="this.value = this.value.replace(/[^a-zA-Z0-9\s]+/g,'').substring(0, 8)"
                  (input)="isZipCodeValid($event.target.value)" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted &&
              AddCustomerForm.get('PostalCode').hasError('required')">
                {{ ErrorMessages.PostcodeRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && CustomerFormControl['PostalCode'].errors?.['minlength']">
                {{ErrorMessages.PostalNotValid}}
              </mat-error>
              <mat-error
                *ngIf="submitted && !isZipValid && !(CustomerFormControl['PostalCode'].errors?.['required']) && !(CustomerFormControl['PostalCode'].errors?.['minlength'])">
                {{ErrorMessages.PostalNotValid}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.City}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput placeholder="Enter Town/City" formControlName="City"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="50" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddCustomerForm.get('City').hasError('required')">
                {{ ErrorMessages.CityRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Country -->
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.Country}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <mat-select [ngClass]="{'preview-mode': IsPreviewTrue}" formControlName="Country" id="style"
                  placeholder="Select Country" #singleSelect >
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Country.." noEntriesFoundLabel="No such country found."
                      [formControl]="CountryCtrl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option panelClass="search-top" *ngFor="let country of FilteredCountry | async" [value]="country.id">
                    {{country.value}}
                  </mat-option>
                </mat-select>

              </mat-form-field>
              <mat-error *ngIf="
                submitted && AddCustomerForm.get('State').hasError('required')">
                {{ ErrorMessages.CountryRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Health Concern -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.HealthConcern}}</mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <textarea matInput placeholder="Enter Health Concern" formControlName="HealthConcern"
                  oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="250"></textarea>

              </mat-form-field>
            </div>
          </div>
        </div>


        <div class="dialogue-footer">
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && !isEditing" type="submit">
            {{LabelConstants.Add}}
          </button>
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && isEditing" type="submit">
            {{LabelConstants.Update}}
          </button>
          <button class="btn btn-info" (click)="cancel()" *ngIf="!IsPreviewTrue" type="button">
            {{LabelConstants.Cancel}}
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>